import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'

import { InternationalNamesCard } from '../components'

export const InternationalNamesPage = () => {
  const { t } = useLocales()

  return (
    <PageBreadcrumbs
      items={[
        {
          title: t('menu.medicines_register')
        },
        {
          title: t('medicine_register.international_name.title')
        }
      ]}
      title={t('medicine_register.international_name.title')}
    >
      <InternationalNamesCard />
    </PageBreadcrumbs>
  )
}
